import React, { useState } from "react";
import { useListAccounts } from "@/lib/api/otc";
import { useListCustomers } from "@/lib/api/customer";
import { Skeleton } from "@/components/ui/skeleton";
import { OtcContractFormV2 } from "./OtcContractForm";
import { OtcFormValues } from "./types";
import { UpdateContractInfo } from "../OtcBearState";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TooltipProvider } from "@/components/ui/tooltip";

const EMPTY_INITIAL_VALUES: OtcFormValues = {
  date: new Date(),
  crop_year: new Date().getFullYear(),
};

export function TestOtcFormV2Page() {
  const accountsRes = useListAccounts(false);
  const customersRes = useListCustomers();
  const [dialogOpen, setDialogOpen] = useState(false);

  const accounts = accountsRes?.data?.data || [];
  const customers = customersRes?.data?.data || [];

  const isLoading = accountsRes.isLoading || customersRes.isLoading;

  const handleSubmit = async (formData: UpdateContractInfo): Promise<boolean> => {
    console.log("Form submitted with data:", formData);
    try {
      await fetch("http://localhost:5000/health", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
    } catch {
      // Ignore network errors — Playwright intercepts this
    }
    return true;
  };

  if (isLoading) {
    return (
      <div className="container flex flex-col gap-4 py-6">
        <h2 className="text-2xl font-bold tracking-tight">OTC Form V2 Test</h2>
        <Skeleton className="h-4 w-[250px]" />
        <Skeleton className="h-4 w-[200px]" />
      </div>
    );
  }

  return (
    <div className="container flex flex-col gap-4 py-6">
      <h2 className="text-2xl font-bold tracking-tight">OTC Form V2 Test</h2>
      <p className="text-sm text-muted-foreground">
        This page renders the new OtcContractFormV2 for testing purposes.
      </p>

      <TooltipProvider>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <Button className="w-fit" data-testid="open-create-form">Open Create Form</Button>
          </DialogTrigger>
          <DialogContent className="max-w-full lg:max-w-[90%] max-h-[90vh] overflow-y-auto flex flex-col flex-start">
            <DialogHeader>
              <DialogTitle>New OTC Contract (V2)</DialogTitle>
            </DialogHeader>
            <OtcContractFormV2
              accounts={accounts}
              customers={customers}
              isUpdateForm={false}
              initialValues={EMPTY_INITIAL_VALUES}
              onSubmit={handleSubmit}
            />
          </DialogContent>
        </Dialog>
      </TooltipProvider>
    </div>
  );
}
